<script>
import moment from "moment";
import {mois} from "@/constants/enums";
import VueMonthlyPicker from "vue-monthly-picker"

export default {
    components: {
        VueMonthlyPicker
    },
    name: "MonthlyPicker",
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: Object,
        clearOption: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        nbMonthsDisabled: {
            type: [Number, Boolean],
            default: 3
        },
        dateFormat: {
            type: String,
            default: 'MM/YYYY'
        }
    },
    data: () => ({
        monthLabels: mois,
    }),
    computed: {
        maxDate() {
            if (this.nbMonthsDisabled !== false) {
                return moment()
            }
            return false
        },
        minDate: function () {
            if (this.nbMonthsDisabled !== false) {
                return moment().subtract(this.nbMonthsDisabled, 'months')
            }
            return false
        }
    }
}
</script>

<template>
    <vue-monthly-picker
        :dateFormat="dateFormat"
        :min="minDate"
        :max="maxDate"
        :monthLabels="monthLabels"
        :value="value"
        @input="$emit('change', $event)"
        :clearOption="clearOption"
        :disabled="disabled"
    >
    </vue-monthly-picker>
</template>
